import { Injectable } from '@angular/core';

import { ShippingMethod } from './shipping.model';

@Injectable({
  providedIn: 'root',
})
export class ShippingTrackableService {
  isTrackable(shippingMethod: ShippingMethod): boolean {
    return shippingMethod.code.startsWith('biteship:');
  }
}
